export default __webpack_public_path__ + "static/media/diediedie.a8bfe14a.jpg";